import { createSlice } from '@reduxjs/toolkit'

export type APP_CONFIG_TYPE = {
  archivePage: 'list' | 'box'
  caseAttachmentsPage: 'list' | 'box'
  caseInboxPage: 'list' | 'box'
}

const initialState: APP_CONFIG_TYPE = {
  archivePage: 'box',
  caseAttachmentsPage: 'box',
  caseInboxPage: 'box',
}

const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    update: (state, { payload }) => {
      if (payload) {
        state.caseInboxPage = payload.caseInboxPage
        state.caseAttachmentsPage = payload.caseAttachmentsPage
        state.archivePage = payload.archivePage
      }
    },
    archivePageViewChange: (state, { payload }) => {
      state.archivePage = payload
      localStorage.setItem(
        'viewType',
        JSON.stringify({
          caseAttachmentsPage: state.caseAttachmentsPage,
          caseInboxPage: state.caseInboxPage,
          archivePage: payload,
        }),
      )
    },
    caseAttachmentsViewChange: (state, { payload }) => {
      state.caseAttachmentsPage = payload
      localStorage.setItem(
        'viewType',
        JSON.stringify({
          caseInboxPage: state.caseInboxPage,
          caseAttachmentsPage: payload,
          archivePage: state.archivePage,
        }),
      )
    },
    caseInboxViewChange: (state, { payload }) => {
      state.caseInboxPage = payload
      localStorage.setItem(
        'viewType',
        JSON.stringify({
          caseAttachmentsPage: state.caseAttachmentsPage,
          archivePage: state.archivePage,
          caseInboxPage: payload,
        }),
      )
    },
  },
})

export const { update, archivePageViewChange, caseAttachmentsViewChange, caseInboxViewChange } =
  appConfigSlice.actions

export default appConfigSlice.reducer
